export default __webpack_public_path__ + "static/media/home.29a7a96e.svg";